module.exports = __webpack_public_path__ + "img/LogoGrandeGio.ce940a02.svg";